import { useNavigate } from "react-router";
import { useTestStore } from "../../hooks/store";
import { useEffect } from "react";
import { testType } from "../../utils/testHelper";

export default function Exam() {
  const testStore = useTestStore();
  const nav = useNavigate();

  const navToSolve = () => {
    // testStore.resetTest();
    nav(`../test?testType=${testType.exam.type}`);
    testStore.setBaseData(testType.exam, "Экзамен ПДД ПМР", 0);
  };

  useEffect(navToSolve, []);
  return;
}
